import { useMemo, useState } from "react";
import { Button, CircleX } from "../../ui";
import "./CRMSchedule.css";
import ScheduleCalendar from "./ScheduleCalendar";
import ScheduleSidebar from "./ScheduleSidebar";

export default function CRMSchedule({ data = [], lang }) {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedItem, setSelectedItem] = useState(null);

  const scheduledItems = useMemo(() => {
    return data.filter((item) => item.crm?.followUpEndDate);
  }, [data]);

  const asapItems = useMemo(() => {
    return data.filter((item) => item.crm?.dateStatus === "asap");
  }, [data]);

  const urgentItems = useMemo(() => {
    return data.filter((item) => item.crm?.dateStatus === "urgent");
  }, [data]);

  return (
    <div className={`crm-schedule ${lang === "ar" ? "rtl" : "ltr"}`}>
      <ScheduleCalendar
        items={scheduledItems}
        currentDate={currentDate}
        setCurrentDate={setCurrentDate}
        lang={lang}
        onCardClick={setSelectedItem}
      />

      <ScheduleSidebar
        asapItems={asapItems}
        urgentItems={urgentItems}
        lang={lang}
        onCardClick={setSelectedItem}
      />

      {selectedItem && (
        <div className="schedule-details-modal" onClick={() => setSelectedItem(null)} role="presentation">
          <div className="schedule-details-card" role="dialog" aria-modal="true" aria-labelledby="schedule-details-title" onClick={(e) => e.stopPropagation()}>
            <Button
              type="button"
              variant="neutral"
              appearance="ghost"
              size="sm"
              rounded
              className="schedule-close-btn"
              icon={<CircleX size={18} />}
              onClick={() => setSelectedItem(null)}
            />

            <h3 id="schedule-details-title">{selectedItem.onboarding?.store?.businessName || "-"}</h3>
            <p>{selectedItem.onboarding?.contact?.contactName || "-"}</p>
            <p>{selectedItem.onboarding?.contact?.mobile || "-"}</p>
            <p>{selectedItem.onboarding?.contact?.email || "-"}</p>
            <p>{selectedItem.onboarding?.documents?.notes || "-"}</p>
          </div>
        </div>
      )}
    </div>
  );
}
